import { render, staticRenderFns } from "./stepper-header.vue?vue&type=template&id=8a55b020&"
import script from "./stepper-header.vue?vue&type=script&lang=js&"
export * from "./stepper-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports